export type SvgEl = React.HTMLAttributes<HTMLOrSVGElement>;

export const IconSkype: React.FC<SvgEl> = (props: SvgEl) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
      <path d="M2.6 40A37.4 37.4 0 0040 77.5a36.8 36.8 0 007-.6A21.5 21.5 0 0058.2 80a21.9 21.9 0 0018.5-33.4 38.1 38.1 0 00.6-6.5A37.4 37.4 0 0040 2.6a38 38 0 00-6.9.6A21.9 21.9 0 003.2 33.4a38.6 38.6 0 00-.6 6.6zm37.8-26.6c12 .7 19 6 19.8 11 .3 3.2-1.8 5.7-5.6 5.7-5.4 0-6-7.2-15.3-7.2-4.3 0-7.8 1.7-7.8 5.6 0 8 30 3.3 30 21 0 10.1-8.1 16.8-20.2 16.8C30.6 66.3 20 61.4 20 53a4.7 4.7 0 014.4-4.8c6.2 0 6.2 9.3 16.2 9.3 7 0 9.3-3.8 9.3-6.5 0-9.6-30.2-3.7-30.2-21.8 0-9.9 8-16.7 20.7-16z" />
    </svg>
  );
};
